
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Loader2 } from 'lucide-react';
import { useUserSubscriptions } from '@/hooks/useUserSubscriptions';
import { useAuth } from '@/context/AuthContext';
import { SubscriptionManagementTable } from './SubscriptionManagementTable';
import { SubscriptionsHeader } from './SubscriptionsHeader';
import { SubscriptionDebugInfo } from './SubscriptionDebugInfo';
import { SubscriptionsFooter } from './SubscriptionsFooter';
import { StripeSync } from './StripeSync';

export function SubscriptionsTab() {
  const { 
    userSubscriptions, 
    loadingSubscriptions, 
    debugInfo, 
    fetchUserSubscriptions 
  } = useUserSubscriptions();
  const { isAdmin } = useAuth();

  return (
    <div className="space-y-6">
      <SubscriptionsHeader />
      
      {isAdmin && <StripeSync />}
      
      <Card>
        <CardContent>
          <SubscriptionDebugInfo 
            debugInfo={debugInfo}
            userSubscriptionsCount={userSubscriptions.length}
            loadingSubscriptions={loadingSubscriptions}
          />
        </CardContent>
      </Card>

      {loadingSubscriptions ? (
        <Card>
          <CardContent className="flex items-center justify-center py-12">
            <Loader2 className="h-8 w-8 animate-spin text-primary" />
            <span className="ml-2">Loading your subscriptions...</span>
          </CardContent>
        </Card>
      ) : (
        <SubscriptionManagementTable 
          subscriptions={userSubscriptions}
          onRefresh={fetchUserSubscriptions}
        />
      )}

      <SubscriptionsFooter />
    </div>
  );
}
